import React from "react";
import { Box, Paper, Typography } from "@mui/material";

const IframeSessionExpired = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      px: 2,
      background:
        "radial-gradient(circle at top center, rgba(255, 192, 155, 0.20), rgba(255,255,255,0) 34%), linear-gradient(180deg, #fffaf6 0%, #fdf6f2 36%, #f8f9fc 100%)",
    }}
  >
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: 460,
        p: { xs: 3, sm: 5 },
        textAlign: "center",
        borderRadius: "24px",
        border: "1px solid rgba(255, 132, 76, 0.12)",
        backgroundColor: "rgba(255,255,255,0.92)",
        boxShadow: "0 24px 60px rgba(236, 123, 55, 0.10)",
      }}
    >
      <Typography
        variant="h5"
        component="h1"
        sx={{ fontWeight: 800, color: "#202531", mb: 1.5 }}
      >
        Your session has expired
      </Typography>
      <Typography sx={{ color: "#6b7280" }}>
        Please refresh the page to continue.
      </Typography>
    </Paper>
  </Box>
);

export default IframeSessionExpired;
